/**
  Copyright (c) [2022]
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
*/

// Vue Imports
import { defineComponent } from 'vue';
// Components Imports
import HeaderDashboard from '@/components/header/header.vue';
import FooterDashboard from '@/components/footer/footer.vue';
import Paginator from '@/components/pagination/pagination.vue';
// Service Imports
import EventService from '@/services/event.ts';
// Third party Components
import VueElementLoading from 'vue-element-loading';
import moment from 'moment';
// Router Imports
import router from '@/router';
// Store
import { mapState, mapActions } from 'vuex';
// Defining Component
export default defineComponent({
  components: {
    HeaderDashboard,
    FooterDashboard,
    Paginator,
    'vue-element-loading': VueElementLoading,
  },
  data() {
    return {
      searchQuery: '',
      pagination: {
        currentPage: 1,
        limit: 15,
        totalPages: 1,
        totalRecords: 0,
      },
      totalPages: 1,
      isloading: false,
      loadStyle: {
        color: '#ffffff',
        'font-weight': 'bold',
        'letter-spacing': '1rem',
        'font-size': '18px',
      },
      list: [],
    };
  },
  methods: {
    ...mapActions('events', ['setSelectedEvent']),
    searchh() {
      let user: any = localStorage.getItem('user');

      if (user) {
        user = JSON.parse(user);

        if (user.userId) {
          this.isloading = true;
          EventService.paginatedEventRecords({
            userId: user.userId,
            size: '15',
            page: '1',
            query: [this.searchQuery.trim()],
          })
            .then((response: any) => {
              debugger;
              this.isloading = false;
              if (response.Result) {
                this.list = response.Result.data;
                this.pagination = response.Result.pagination;
              }
            })
            .catch((err: any) => {
              this.isloading = false;
            });
        }
      }
    },
    nextPage(pgno: any) {
      let user: any = localStorage.getItem('user');

      if (user) {
        user = JSON.parse(user);

        if (user.userId) {
          this.isloading = true;
          EventService.paginatedEventRecords({
            userId: user.userId,
            size: '15',
            page: pgno,
          })
            .then((response: any) => {
              this.isloading = false;
              if (response.Result) {
                this.list = response.Result.data;
                this.pagination = response.Result.pagination;
              }
            })
            .catch((err: any) => {
              this.isloading = false;
            });
        }
      }
    },
    currentUserPicure(imgStr: string) {
      const user = localStorage.getItem('user');

      if (user) {
        const parseduser = JSON.parse(user);
        return (
          'https://storage.googleapis.com/s8w80ukr9zgzqst5era7u9uh1eo5uf81kibwqdsu6j4f1mh7tw/' +
          imgStr
        );
      }

      return null;
    },
    removeunderscore(text: string) {
      const data = text.replaceAll('_', ' ').toLowerCase().split(' ');
      for (let i = 0; i < data.length; i++) {
        data[i] = data[i][0].toUpperCase() + data[i].substr(1);
      }
      return data.join(' ');
    },
    getDate(date: string) {
      return moment(date).format('MMM DD, YYYY');
    },
    getTime(date: string) {
      return moment(date).format('hh:mm A');
    },
    showDetail(record: any) {
      console.log(record);
      localStorage.setItem('record', JSON.stringify(record));
      this.setSelectedEvent(record);
      router.push({
        name: 'event-dashboard',
      });
    },
    aaa(s: any) {
      alert(s);
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  created() {
    localStorage.removeItem('record');
    localStorage.removeItem('record1');
    let user: any = localStorage.getItem('user');

    if (user) {
      user = JSON.parse(user);

      if (user.userId) {
        this.isloading = true;
        EventService.paginatedEventRecords({
          userId: user.userId,
          size: '15',
          page: '1',
        })
          .then((response: any) => {
            debugger;
            this.isloading = false;
            if (response.Result) {
              this.list = response.Result.data;
              this.pagination = response.Result.pagination;
            }
          })
          .catch((err: any) => {
            this.isloading = false;
          });
      }
    }
  },
});
